import {
  Product,
  RetiredProduct,
  RetiredVariant,
  Variant,
} from "../../types/types";

export function ensureIsRetired(product: Product): RetiredProduct | null {
  const isRetired =
    product.__typename === "RetiredSimpleProduct" ||
    product.__typename === "RetiredCompositeBundle" ||
    product.__typename === "RetiredStaticBundle";

  if (isRetired) {
    return product;
  } else {
    return null;
  }
}

export function ensureIsRetiredVariant(
  variant: Variant,
): RetiredVariant | null {
  const isRetired =
    variant.__typename === "RetiredStockVariant" ||
    variant.__typename === "RetiredCompositeBundleVariant" ||
    variant.__typename === "RetiredStaticBundleVariant";

  if (isRetired) {
    return variant;
  } else {
    return null;
  }
}
